import Collection from './Collection'
export default class ApplicationsCollection extends Collection{
  COLLECTION='applications'
}